import { h, Component, createRef } from "preact";

import TextField from "./TextField.jsx";

function pad(value) {
  return (value < 10 ? "0" : "") + value;
}

function formattedDate(date, format) {
  const dd = pad(date.getDate());
  const mm = pad(date.getMonth() + 1);
  const yyyy = date.getFullYear();

  if ((format || "").toLowerCase() === "yyyy-mm-dd")
    return `${yyyy}-${mm}-${dd}`;
  return `${dd}/${mm}/${yyyy}`;
}

export default class Datepicker extends Component {
  ref = createRef();

  componentDidMount() {
    let minDate = this.props.min || null;
    let maxDate = this.props.max || null;
    M.AutoInit(this.ref.current.base);
    const thisYear = new Date().getFullYear();
    let minYear = thisYear - 100;
    let maxYear = thisYear + 20;
    if (minDate === "today") {
      minDate = new Date();
      minYear = minDate.getFullYear();
    }
    if (maxDate === "today") {
      maxDate = new Date();
      maxYear = maxDate.getFullYear();
    }
    const format = this.props.format || "dd/mm/yyyy";
    M.Datepicker.init(this.ref.current.base.querySelector("input"), {
      autoClose: true,
      firstDay: 1,
      format: format,
      minDate,
      maxDate,
      yearRange: [minYear, maxYear],
      onOpen: this.props.onOpen,
      onClose: this.props.onClose,
      onSelect: (date) => {
        this.props.onChange &&
          this.props.onChange(formattedDate(date, this.props.format));
        this.props.onInput &&
          this.props.onInput(formattedDate(date, this.props.format));
      },
    });
  }

  render() {
    const { min, max, onChange, ...inputProps } = this.props;

    return (
      <TextField
        {...inputProps}
        onChange={(event) => onChange(event.target.value)}
        onInput={(event) => onChange(event.target.value)}
        ref={this.ref}
      />
    );
  }
}
